export var Direction;

(function (Direction) {
  Direction["AUTO"] = "auto";
  Direction["AUTO_START"] = "auto-start";
  Direction["AUTO_END"] = "auto-end";
  Direction["RIGHT"] = "right";
  Direction["RIGHT_START"] = "right-start";
  Direction["RIGHT_END"] = "right-end";
  Direction["TOP"] = "top";
  Direction["TOP_START"] = "top-start";
  Direction["TOP_END"] = "top-end";
  Direction["BOTTOM"] = "bottom";
  Direction["BOTTOM_START"] = "bottom-start";
  Direction["BOTTOM_END"] = "bottom-end";
  Direction["LEFT"] = "left";
  Direction["LEFT_START"] = "left-start";
  Direction["LEFT_END"] = "left-end";
})(Direction || (Direction = {}));